import type { ProjectTransactionNotification } from "@/types/api";

/**
 * Applying a completed character/location/shot/video generation is always a "prepend/move to
 * front" for whichever transaction is applied last. Notifications are fetched newest-first (for
 * display), so applying them in that order made the *older* request win the front/primary slot
 * whenever two generations for the same tag completed close together. Sorting oldest-first before
 * applying means results always land in request order, regardless of which one the provider
 * happened to finish processing first.
 */
export function oldestRequestedFirst(
  transactions: readonly ProjectTransactionNotification[]
): readonly ProjectTransactionNotification[] {
  return transactions.toSorted((a, b) => {
    const delta = (a.timestamp_start ?? 0) - (b.timestamp_start ?? 0);
    return delta === 0 ? a.transaction_id.localeCompare(b.transaction_id) : delta;
  });
}
